import { styled, alpha } from "@mui/material/styles";
import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ToggleButton from "@mui/material/ToggleButton";
import { grey } from "@mui/material/colors";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DataJacketAutocomplete } from "../other/formControl";
import { getFullDataJacketList } from "../../js/queriesHandling";
import { CssBtnTypography, CssDataJacketButton } from "../../styles/styled";
import { ChildModal } from "./dataJacketSelectNodeModal";
import { Auth, Hub } from "aws-amplify";

const CssParentBox = styled(Box)({
  maxWidth: "1300px",
  paddingBottom: "32px",
  paddingLeft: "56px",
  paddingRight: "32px",
  marginTop: "16px",
  marginLeft: "auto",
  marginRight: "auto",
});

const CssChildBox = styled(Box)({
  marginTop: "16px",
  marginLeft: "16px",
  marginRight: "16px",
});

const SearchToggleButton = styled(ToggleButton)(({ theme }) => ({
  backgroundColor: grey[800],
  "&:hover": {
    background: alpha(theme.palette.common.white, 0.25),
  },
}));

let defaultDJ = [{ id: 1, value: "", datajacketId: "" }];

export function NewNetWorkPage({
  handleCloseModal,
  setTempFlg,
  setContinuousSaving,
  setSavedId,
}) {
  const [compDataJacket, setCompDataJacket] = React.useState([]);
  const [newListOfDataJacket, setNewListOfDataJacket] = React.useState([]);
  const [currentDJIndex, setCurrentDJIndex] = React.useState(1);
  const [datajackets, setDataJackets] = React.useState(defaultDJ);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [user, setUser] = React.useState(null);

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }

  React.useEffect(() => {
    try {
      getNodeDetail();
    } catch {}
  }, [user]);

  React.useEffect(() => {
    try {
      checkUser();
      Hub.listen("auth", (data) => {
        const { payload } = data;
        if (payload.event === "signOut") {
          setUser(null);
        }
      });
    } catch {}
  }, []);

  async function getNodeDetail() {
    try {
      setCompDataJacket(await getFullDataJacketList(user.username));
    } catch (e) {}
  }
  const handleCloseError = () => {
    setAlertOpen(false);
  };
  const handleOpenError = () => {
    setAlertOpen(true);
  };
  function checkDataJacket() {
    setTempFlg(false);
    setContinuousSaving(false);
    setSavedId("");
    let cleanedData = datajackets.filter(
      (a) => a.value !== undefined && a.value !== ""
    );
    if (cleanedData.length > 0) {
      handleCloseModal(cleanedData);
    } else {
      handleOpenError();
    }
  }

  function createMenuItem() {
    try {
      var arrIds = compDataJacket.data_jacket_ids.split(",");
      var arrMyIds = compDataJacket.my_data_jacket_ids.split(",");
      var arrNames = compDataJacket.data_jacket_names.split("[spl]");
      var arrMyNames = compDataJacket.my_data_jacket_names.split("[spl]");
      var list = [];
      if (arrMyIds.length > 0 && arrMyIds[0].length === 10) {
        for (var i = 0; i < arrMyIds.length; i++) {
          list.push({
            label: String("[My]") + arrMyNames[i],
            id: arrMyIds[i],
            name: arrMyNames[i],
          });
        }
        setNewListOfDataJacket(list);
      }

      if (arrIds.length > 0 && arrIds[0].length === 10) {
        for (var s = 0; s < arrIds.length; s++) {
          list.push({
            label: String("[" + (s + 1) + "]") + arrNames[s],
            id: arrIds[s],
            name: arrNames[s],
          });
        }
        setNewListOfDataJacket(list);
      }
    } catch (e) {}
  }

  function handleSelect(selectedId, selectedValue, selectedDatajacketId) {
    try {
      handleCloseError();
      setDataJackets(
        datajackets.map((datajacket) => {
          if (datajacket.id === selectedId) {
            return {
              ...datajacket,
              id: selectedId,
              value: selectedValue,
              datajacketId: selectedDatajacketId,
            };
          } else {
            return datajacket;
          }
        })
      );
    } catch (e) {}
  }

  React.useEffect(() => {
    createMenuItem();
  }, [compDataJacket]);

  return (
    <CssParentBox>
      <CssChildBox>
        <Grid
          container
          alignItems="center"
          spacing={3}
          columns={12}
          style={{ marginTop: "16px", backgroundColor: "#505458" }}
        >
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              alignItems: "center",
            }}
          ></Grid>
          {datajackets.map((datajacket) => (
            <DataJacketAutocomplete
              key={datajacket.id}
              index={datajacket.id}
              handleSelectOnChange={handleSelect}
              currentList={newListOfDataJacket}
            />
          ))}
          <Grid
            item
            xs={12}
            style={{
              alignItems: "center",
              color: "white",
              paddingBottom: "13px",
            }}
          >
            <SearchToggleButton
              value="bold"
              aria-label="bold"
              onClick={() => {
                setDataJackets([
                  ...datajackets,
                  { id: currentDJIndex + 1, value: "", datajacketId: "" },
                ]);
                setCurrentDJIndex(currentDJIndex + 1);
              }}
            >
              <AddCircleOutlineOutlinedIcon sx={{ color: "white" }} />
              <CssBtnTypography>　データジャケット追加</CssBtnTypography>
            </SearchToggleButton>
          </Grid>
          <Grid
            container
            xs={12}
            columns={10}
            style={{
              color: "white",
              paddingBottom: "13px",
            }}
          >
            <Grid xs="5"></Grid>
            <Grid xs="5" style={{ display: "flex", justifyContent: "right" }}>
              <CssDataJacketButton
                style={{ width: "260px", marginRight: "16px" }}
                onClick={checkDataJacket}
              >
                データネットワーク図作成
              </CssDataJacketButton>
            </Grid>
          </Grid>
        </Grid>
      </CssChildBox>
      {alertOpen && (
        <ChildModal
          open={alertOpen}
          setOpen={handleCloseError}
          message={"データジャケット起点を一つ選択してください。"}
        />
      )}
    </CssParentBox>
  );
}
